import { ApplicationRef, Component, OnInit } from '@angular/core';
import { FirebaseApp } from '@angular/fire';
import { FacebookService, InitParams } from 'ngx-facebook';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(@Inject(PLATFORM_ID) private platformId: Object, public readonly firebaseApp: FirebaseApp, appRef: ApplicationRef, private facebookService: FacebookService) {
    appRef.isStable.subscribe();
  }

  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {
      // Facebook SDK related code here
       this.initFacebookService()
    }
   
  }

  private initFacebookService(): void {
    const initParams: InitParams = {
      xfbml: true,
      version: 'v2.8'
    };
    this.facebookService.init(initParams);
  }
}
